import React from "react";
import styled from 'styled-components';
import FlexColumn from "../../order/components/FlexColumn";
import style from './style';
import SetupItemList from "../setup-item-list";
import {columns, prototype} from "./setup";
import VehicleTypeGeneral from "./vehicle-type-general";

const Styled = styled(FlexColumn)`${style}`;

const tabs = [
  {
    label: 'General',
    component: VehicleTypeGeneral,
  },
]

const SetupVehicleTypes = () => {
  return (
    <Styled>
      <SetupItemList
        typeId='vehicle-type'
        type='Vehicle Type'
        columns={columns}
        prototype={prototype}
        editorType='tabs'
        tabs={tabs}
      />
    </Styled>
  )
}

export default SetupVehicleTypes;
